import clsx from 'clsx'
import { rem } from 'polished'
import React, { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import LineLuxuryEscapesMonogramIcon from './Icons/line/LineLuxuryEscapesMonogramIcon'
import { PILL_HEIGHT } from './Pill'
import CaptionTextBlock from './TextBlocks/CaptionTextBlock'

const Container = styled.div`
  height: ${PILL_HEIGHT};
  border-radius: ${props => props.theme.borderRadius.round};
  max-width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding-inline: ${rem(4)} ${rem(8)};
  border: 1px solid transparent;

  &.variant-primary {
    &.tier-bronze {
      background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
      border-color: ${props => props.theme.palette.product.loyalty.bronze.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    }
    &.tier-silver {
      background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
      border-color: ${props => props.theme.palette.product.loyalty.silver.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    }
    &.tier-gold {
      background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
      border-color: ${props => props.theme.palette.product.loyalty.gold.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    }
    &.tier-platinum {
      background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
      border-color: ${props => props.theme.palette.product.loyalty.platinum.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
    }
  }
  &.variant-secondary {
    &.tier-bronze {
      background-color: ${props => props.theme.palette.product.loyalty.bronze.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.bronze.darkForeground};
      color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    }
    &.tier-silver {
      background-color: ${props => props.theme.palette.product.loyalty.silver.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.silver.darkForeground};
      color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    }
    &.tier-gold {
      background-color: ${props => props.theme.palette.product.loyalty.gold.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.gold.darkForeground};
      color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    }
    &.tier-platinum {
      background-color: ${props => props.theme.palette.product.loyalty.platinum.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.platinum.darkForeground};
      color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
    }
  }
`

interface Props extends PropsWithChildren {
  tier: App.LoyaltyTier
  variant: 'primary' | 'secondary'
  endIcon?: ReactElement | false
}

function LoyaltyTierPill({ tier, variant, endIcon, children }: Props) {
  return <Container className={clsx(`tier-${tier}`, `variant-${variant}`)}>
    <CaptionTextBlock
      variant="medium"
      weight="bold"
      startIcon={<LineLuxuryEscapesMonogramIcon />}
      endIcon={endIcon}
    >
      {children}
    </CaptionTextBlock>
  </Container>
}

export default LoyaltyTierPill
